<script setup>
import { useI18n } from '../../i18n.js'
import { computed } from 'vue'
import { XMarkIcon } from '@heroicons/vue/20/solid'
import { entityAppearanceStyle } from '../../pts2/entityAppearance.js'

const { t } = useI18n()

const props = defineProps({
  entityId: { type: [Number, String], default: null },
  label: { type: String, required: true },
  removable: { type: Boolean, default: true },
  appearance: { type: String, default: 'entity' },
  removeLabel: { type: String, default: '' },
})
const emit = defineEmits(['remove'])
const neutralStyle = {
  '--entity-background': '#eaf4f5',
  '--entity-border': '#b8d3d8',
  '--entity-foreground': '#185466',
  '--entity-dot': '#21879a',
}
const style = computed(() => props.appearance === 'neutral'
  ? neutralStyle : entityAppearanceStyle(props.entityId, props.label))
</script>

<template>
  <button v-if="removable" class="pts2-filter-chip" :style="style" type="button"
    :aria-label="removeLabel || t('pts2UiHistoryRemove', { label })" @click="emit('remove')">
    <i aria-hidden="true"></i><span>{{ label }}</span><XMarkIcon aria-hidden="true" />
  </button>
  <span v-else class="pts2-filter-chip static" :style="style">
    <i aria-hidden="true"></i><span>{{ label }}</span>
  </span>
</template>
